import React, { useEffect, useState } from 'react';
import Nav from '../speech2text/s2tranNav/S2tranNav'
import './auth.scss'
import { countryList } from './countries';
import { Link, useHistory } from 'react-router-dom';
import { database } from '../../utils/firebase';
import { useDispatch, useSelector } from 'react-redux';
import { storeUserId } from '../../redux/actions/authActions';
import { Helmet } from 'react-helmet';

const Auth = () => {

    const [registerState, setRegisterState] = useState({
        fullname: '',
        regEmail: '',
        phone: '',
        country: ''
    })
    const [loginState, setLoginState] = useState({
        logEmail: '',
        noOfView: '',
        language: '',
    })
    const [auth, setAuth] = useState({
        eventID: '',
        eventUsers: [],
        access: '',
    })
    const [error, setError] = useState('error')
    const { eventID, eventUsers, access } = auth
    const { fullname, regEmail, phone, country} = registerState
    const { logEmail, noOfView, language } = loginState
    const [languageData, setLanguageData] = useState([])
    const [userData, setUserData] = useState([])
    const [regError, setRegError] = useState('error')
    const [currentPage, setCurrentPage] = useState('login')
    const [status, setStatus] = useState(false)
    const [loginUserData, setLoginUserData] = useState('')
    const [eventsData, setEventsData] = useState([])
    const [localStoreUserData, setLocalStoreUserData] = useState('')
    const user = useSelector(state => state.user)
    const [newData, setNewData] = useState([])
    const { userID, lvcconnectEventUserId } = user
    let history = useHistory()
    const dispatch = useDispatch()

    useEffect(() => {
        if(eventID) {        
           if (lvcconnectEventUserId) {
                if(eventUsers.length > 0) {         
                    const bb = eventUsers.some(el => {return el.id === lvcconnectEventUserId})
                    if (bb) {
                        // history.push('/stream/' + eventDbUserId)
                        // History.push brings a bug that I am not ready to fix but window.location doesn't bring said bug so thats what I am using instead
                        // During Development Please Uncomment 'http://localhost:3000/stream/' and Comment 'https://itranslatectx.web.app/stream/'
                        // window.location = 'http://localhost:3000/stream/' + lvcconnectEventUserId
                        // Before Deploying ENSURE You Comment 'http://localhost:3000/stream/' and Uncomment 'https://itranslatectx.web.app/stream/'
                        window.location = 'https://lvzconnect.web.app/stream/' + lvcconnectEventUserId
                    } 
                }     
            } 
        }
    }, [dispatch, eventID, eventUsers, lvcconnectEventUserId,])



    useEffect(() => {
        const eventRef = database.ref('Events')

        eventRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }

            if (eData.length !== eventsData.length) {
                setEventsData(eData)
            } 
            

            
        })

        const check = eventsData.some(el => {
            return el.eventStatus === 'Live'
        })

        if(check) {
            eventsData.forEach(el => {
                if (el.eventStatus === 'Live') {
                    setAuth({
                        ...auth,
                        eventID: el.id
                    })
                    return
                }
            })
        }
        if (!check) {
            eventsData.forEach(el => {
                if (el.eventStatus === 'Default') {
                    setAuth({
                        ...auth,
                        eventID: el.id
                    })
                    return
                }
            })  
                
            }

    }, [eventsData])




    useEffect(() => {
        const langRef = database.ref('Languages')
        langRef.on('value', (el) => {
            let eData =[] 
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }
            setLanguageData(eData)
        })
    }, [])





    useEffect(() => {
        const userRef = database.ref('Users')
        userRef.on('value', (el) => {
            let eData =[] 
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }
            setUserData(eData)
        })

        if(eventID) {
            const eventRef = database.ref('Events').child(eventID).child('Users')
            eventRef.on('value', (el) => {
                let eData =[] 
                for (let id in el.val()) {
                    eData.push({id, ...el.val()[id]})
                }
                    if(eData.length === 0) {
                        setAuth({
                            ...auth,
                            eventUsers: ["null"]
                        })
                    } else {
                        setAuth({
                            ...auth,
                            eventUsers: eData
                        })
                    }
                    
        })
        }
        
    }, [eventID])






    useEffect(() => {
        
        if(userID) {
            setError('error')
            const bb = eventUsers.some(el => {return el.userId === userID})
            if (bb) {
            
                let eventDbUserId
                eventUsers.forEach(el => {
                    if(userID === el.userId) {
                        eventDbUserId = el.id
                    } }) 
                const eventRef = database.ref('Events').child(eventID).child('Users').child(eventDbUserId)
                
                eventRef.update({
                    noOfViewers: +noOfView,
                    preferredLanguage: language,
                    loggedInAt:  Date.now(),
                    loggedOut: ''
                })

                // history.push('/stream/' + eventDbUserId)
                // History.push brings a bug that I am not ready to fix but window.location doesn't bring said bug so thats what I am using instead
                // During Development Please Uncomment 'http://localhost:3000/stream/' and Comment 'https://itranslatectx.web.app/stream/'
                // window.location = 'http://localhost:3000/stream/' + eventDbUserId
                // Before Deploying ENSURE You Comment 'http://localhost:3000/stream/' and Uncomment 'https://itranslatectx.web.app/stream/'
                window.location = 'https://lvzconnect.web.app/stream/' + eventDbUserId
                setStatus(false)
                dispatch(storeUserId(''))

            } else {
                let cc

                const eventRef = database.ref('Events').child(eventID).child('Users')
                userData.forEach(el => {
                    if(userID === el.id) {
                        cc = el
                    } })       
                const newEventUser = {
                    country: cc.country,
                    name: cc.name,
                    email: cc.email,
                    phone: cc.phone,
                    userId: userID,
                    noOfViewers: +noOfView,
                    preferredLanguage: language,
                    loggedInAt:  Date.now(),
                    loggedOut: ''
                }

                eventRef.push(newEventUser)

                const ddRef = database.ref('Events').child(eventID).child('Users')
                ddRef.on('value', (el) => {
                    let eData =[] 
                    for (let id in el.val()) {
                        eData.push({id, ...el.val()[id]})
                    }
                        setNewData(eData)
                })

            }
  
        }
    }, [eventID, history, language, noOfView, userID])


    useEffect(() => {
        if(newData.length > 0) {
            let eventDbUserId
                newData.forEach(el => {
                    if(userID === el.userId) {
                        eventDbUserId = el.id
                    } }) 
                if (eventDbUserId) {
                    // history.push('/stream/' + eventDbUserId)
                    // History.push brings a bug that I am not ready to fix but window.location doesn't bring said bug so thats what I am using instead
                    // During Development Please Uncomment 'http://localhost:3000/stream/' and Comment 'https://itranslatectx.web.app/stream/'
                    // window.location = 'http://localhost:3000/stream/' + eventDbUserId
                    // Before Deploying ENSURE You Comment 'http://localhost:3000/stream/' and Uncomment 'https://itranslatectx.web.app/stream/'
                    window.location = 'https://lvzconnect.web.app/stream/' + eventDbUserId
                } 
                setStatus(false)
                dispatch(storeUserId(''))
        }
    }, [dispatch, newData, userID])

    
    const handleRegisterSubmit = (e) => {
        e.preventDefault()
        setStatus(true)

        const bb = userData.some(el => {
            return regEmail === el.email
        })


        if (bb) {
            setRegError('Email Already Exist')
            setStatus(false)
            return 
        } else {
            setRegError('error')

            const userRef = database.ref('Users')
            const newUser = {
                name: fullname,
                email: regEmail,
                phone: phone,
                country: country,
                joinedAt: Date.now()
            }

            userRef.push(newUser)
            setStatus(false)
            setRegisterState({
                fullname: '',
                regEmail: '',
                phone: '',
                country: ''
            })
            setCurrentPage('success')
        }

        
    }

    const handleLoginSubmit = (e) => {
        e.preventDefault()
        setStatus(true)

        const bb = userData.some(el => {
            return logEmail === el.email
        })

        if (!bb) {
            setError('Email not found!')
                setStatus(false)
                return 
        }

        userData.forEach(el => {
            if(logEmail === el.email) {
                setError('error')
                return dispatch(storeUserId(el.id))   
            }
        })
    
    }

    const closeNav = () => {
        document.querySelector('.backgroundj').classList.add('hide')
        document.querySelector('.nav-bar').classList.add('hide') 
        document.querySelector('.stream-give').classList.add('hide') 
    }


    return (
        <div className="register intro">
            <Helmet htmlAttributes>
                    <meta charSet="utf-8" />
                    <html lang="en" />
                    <title>{currentPage[0].toUpperCase() + currentPage.slice(1).toLowerCase()} | LVZConnect</title>
                    <meta name="description" content="LVZConnect Authentication Page" />
            </Helmet>
            <Nav backClass={'backgroundj'} />
            <div className='backgroundj background hide' onClick={closeNav}></div>
            <img src="https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60" alt="" className='banner'/>

            <h1>{currentPage === 'register'? 'Register' : currentPage === 'login'? 'Login' : currentPage === 'success'? 'Congratulations' : ''}</h1>

            
            <div className="form-container">
                {currentPage === 'register'? 
                <form action="" className="reg register-form" onSubmit={handleRegisterSubmit}>
                    <div className="form-element">
                        <label htmlFor="fullname">Full Name <span>*</span></label>
                        <input required type="text" id='fullname' name='fullname' className='field' 
                        value={fullname} onChange={(e) => setRegisterState({ ...registerState, fullname: e.target.value})}/>
                    </div>

                    <div className="form-element">
                        <label htmlFor="reg-email">Email <span>*</span></label>
                        <input required type="email" id='reg-email' name='reg-email' className='field' 
                        value={regEmail} onChange={(e) => setRegisterState({ ...registerState, regEmail: e.target.value})}/>
                    </div>

                    <div className="form-element">
                        <label htmlFor="reg-no">Phone Number <span>*</span></label>
                        <input required type="number" id='reg-no' name='reg-no' className='field' 
                        value={phone} onChange={(e) => setRegisterState({ ...registerState, phone: e.target.value})}/>
                    </div>

                    <div className="form-element">
                        <label htmlFor="country">Country <span>*</span></label>
                        {/* <input required type="text" id='country' name='country' className='field' 
                        value={country} onChange={(e) => setCountry(e.target.value)}/> */}
                        <select required id='country' name='country' className='field' value={country} onChange={(e) => {setRegisterState({ ...registerState, country: e.target.value}); console.log(e.target.value)}}>
                            <option value="" defaultValue></option>
                            {countryList.map(el => {
                                if(el.name === 'NIGERIA') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}
                            {countryList.map(el => {
                                if(el.name === 'UNITED STATES') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'UNITED KINGDOM') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'SOUTH AFRICA') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'CHINA') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'TURKEY') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'MONGOLIA') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name === 'GHANA') {
                                return (
                                    <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                )
                                }
                            })}

                            {countryList.map(el => {
                                if(el.name !== 'MONGOLIA' && el.name !== 'GHANA' && el.name !== 'TURKEY' && el.name !== 'CHINA' && el.name !== 'SOUTH AFRICA' && el.name !== 'UNITED KINGDOM' && el.name !== 'UNITED STATES' && el.name !== 'NIGERIA') {
                                    return (
                                        <option value={el.name[0].toUpperCase() + el.name.slice(1).toLowerCase()}>{el.name}</option>
                                    )
                                }
                            })}
                        </select>
                    </div>
                    <div className="bottom">
                    <p className={`error ${regError !== 'error' ? 'show' : ''}`}>{regError}</p>
                        <button disabled={status}>Submit</button>
                        <p>Already have an account? <Link  onClick={() => {
                            if(status) {
                                return
                            }
                            setCurrentPage('login')
                            
                            }}>LOGIN HERE</Link></p>
                    </div>
                    
                </form> : 
                
                currentPage === 'login'?
                
                <form action="" className="login register-form" onSubmit={handleLoginSubmit}>
                    <div className="form-element">
                        <label htmlFor="fullname">Email <span>*</span></label>
                        <input required type="email" id='fullname' name='fullname' className='field' 
                        value={logEmail} onChange={(e) => setLoginState({ ...loginState, logEmail: e.target.value})}/>
                    </div>

                    <div className="form-element">
                        <label htmlFor="reg-no">No of viewers watching with you <span>*</span></label>
                        <input required type="number" id='reg-no' name='reg-no' className='field' 
                        value={noOfView} onChange={(e) => setLoginState({ ...loginState, noOfView: e.target.value})}/>
                    </div>

                    <div className="form-element">
                        <label htmlFor="p-lang">Preferred Language <span>*</span></label>
                        <select required id='p-lang' name='p-lang' className='field' value={language} onChange={(e) => setLoginState({ ...loginState, language: e.target.value})}>
                            <option value="" defaultValue></option>
                            {languageData.map(el => {
                                if(el.language === 'English') {
                                    return (
                                        <option value={el.language}>{el.language.toUpperCase()}</option>
                                    )
                                }
                                
                            })}

                            {languageData.map(el => {
                                if(el.language !== 'English') {
                                    return (
                                        <option value={el.language}>{el.language.toUpperCase()}</option>
                                    )
                                }
                                
                            })}
                        </select>
                    </div>
                    <div className="bottom">
                        <p className={`error ${error !== 'error' ? 'show' : ''}`}>{error}</p>
                        <button disabled={status}>Watch Live</button>
                        <p>Don't have an account? <Link onClick={() => {
                            if(status) {
                                return
                            }
                            setCurrentPage('register')
                            
                            }}>REGISTER HERE</Link></p>
                    </div>
                    
                </form> :

                currentPage === 'success'? 

                <div className="success ">
                    <div className="top">
                        <p>You have successfully registered</p>
                        <i class="fas fa-check-square"></i>
                    </div>
                    
                    <Link onClick={() => setCurrentPage('login')}>CLICK HERE TO LOGIN</Link>
                </div>
                : ''}
                
            </div>

            <footer className='admin-footer'>
                <p>Made with ❤️ by Virtual Church Team. LVZ Connect! A Group Church of CELVZ © 2021.<br /> All rights reserved.</p>
            </footer>
            
        </div>
        
    )
}

export default Auth